import { useEffect, useState } from "react";
import UserDonationTable from "./UserDonationTable/UserDonationTable";
import { useSelector } from "react-redux";
import Spinner from "../../shared/LoadingSpinner/Spinner";
import { fetchUserDonations } from "../../../api/Donations";

const PAGE_SIZE = 50;

export default function UserDonationList() {
  const [isLoading, setIsLoading] = useState(true);
  const [localUserData, setLocalUserData] = useState(null);
  const [donationsDetails, setDonationsDetails] = useState([]);
  const [npDonationsDetails, setNpDonationsDetails] = useState([]);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const userData = useSelector((state) => state.userData.userData);

  const getUserDonations = async (userId, p) => {
    try {
      const response = await fetchUserDonations(userId, p);

      if (response) {
        setDonationsDetails(response.results || []);
        setTotalCount(response.count || 0);
        setPageCount(Math.ceil((response.count || 0) / PAGE_SIZE));
      }
      setIsLoading(false);
    } catch (error) {
      // Handle or throw error
      if (error.response && error.response.status === 500) {
        console.error("500 Internal Server Error");
        throw error;
      } else {
        console.error("Error getting user donations:", error.response);
        throw error;
      }
    }
  };
  // Retrieve user data from localStorage
  useEffect(() => {
    if (Object.keys(userData).length !== 0) {
      const parsedUserData = JSON.parse(userData);
      setLocalUserData(parsedUserData);
      if (parsedUserData.general_donations_details)
        setNpDonationsDetails(parsedUserData.general_donations_details);
    }
  }, [userData]);

  useEffect(() => {
    if (localUserData) {
      getUserDonations(localUserData.id, page);
    }
  }, [localUserData, page]);

  return (
    <div className={`mx-auto pt-0 lg:pt-12 w-full lg:w-4/6`}>
      {isLoading ? (
        <div className="flex flex-row ml-auto mt-[25vh] w-full h-full justify-center">
          <Spinner />
        </div>
      ) : (
        <UserDonationTable
          data={donationsDetails}
          npData={npDonationsDetails}
          serverPageCount={pageCount}
          serverTotalCount={totalCount}
          onServerPageChange={setPage}
        />
      )}
    </div>
  );
}
